import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMasonryModule } from 'ngx-masonry';
import { PaginatorModule } from '../paginator/paginator.module';
import { DropdownSortModule } from '../filters/dropdown-sort/dropdown-sort.module';
import { PerPageDropdownModule } from '../filters/per-page-dropdown/per-page-dropdown.module';
import { ArtsaasPipesModule } from '../shared/artsaas-pipes.module';
import { TranslatePipesModule } from '../shared/translate-pipes.module';
import { ImagesPresentationModule } from '../images-presentation/images-presentation.module';
import { BlocksWrapperModule } from '../blocks-wrapper/blocks-wrapper.module';
import { ModalFormModule } from '../modal-form/modal-form.module';
import { SocialShareModule } from '../social-share/social-share.module';
import { ExhibitionsComponent } from './exhibitions.component';
import { ExhibitionItemComponent } from './exhibition-item.component';
import { ExhibitionsRoutingModule } from './exhibitions-routing.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ExhibitionsRoutingModule,
    PaginatorModule,
    DropdownSortModule,
    PerPageDropdownModule,
    ImagesPresentationModule,
    NgxMasonryModule,
    ModalFormModule,
    SocialShareModule,
    ArtsaasPipesModule,
    TranslatePipesModule,
    BlocksWrapperModule,
    SharedModule,
  ],
  declarations: [
    ExhibitionsComponent,
    ExhibitionItemComponent,
  ],
})
export class ExhibitionsModule {
}
